module.exports = __webpack_public_path__ + "img/contact.e04a51bd.png";